import { Component, Input } from "@angular/core";

@Component({
    selector: "app-basic-video-player",
    templateUrl: "./basic-video-player.component.html",
    styleUrls: ["./basic-video-player.component.scss"]
})
export class BasicVideoPlayerComponent {
    @Input("linkVideo")
    public linkVideo!: string;

    @Input("typeVideo")
    public typeVideo!: string;
}
